// Competition ranking: equal money totals share a place and skip the next place.
export function rankEntries(entries, scoreKey) {
  const cents = entry => Math.round(Number(entry[scoreKey] || 0) * 100)
  const sorted = [...entries].sort((a, b) => cents(b) - cents(a))
  const counts = new Map()
  sorted.forEach(entry => counts.set(cents(entry), (counts.get(cents(entry)) || 0) + 1))
  let rank = 0
  return sorted.map((entry, index) => {
    if (index === 0 || cents(entry) !== cents(sorted[index - 1])) rank = index + 1
    return { ...entry, rank: entry.rank ?? rank, tied: entry.tied ?? counts.get(cents(entry)) > 1 }
  })
}

export function rankLabel({ rank, tied }) {
  const medal = { 1: '🥇', 2: '🥈', 3: '🥉' }[rank]
  return `${medal ? `${medal} ` : ''}${tied ? 'T' : ''}${rank}`
}

export function rankTimedEntries(entries) {
  const sorted = [...entries].sort((a, b) => b.accuracy - a.accuracy || a.elapsed_ms - b.elapsed_ms)
  const key = entry => `${entry.accuracy}:${entry.elapsed_ms}`
  const counts = new Map()
  sorted.forEach(entry => counts.set(key(entry), (counts.get(key(entry)) || 0) + 1))
  let rank = 0
  return sorted.map((entry, index) => {
    if (index === 0 || key(entry) !== key(sorted[index - 1])) rank = index + 1
    return { ...entry, rank: entry.rank ?? rank, tied: entry.tied ?? counts.get(key(entry)) > 1 }
  })
}
